import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-care-labels',
  templateUrl: './care-labels.component.html',
  styleUrls: ['./care-labels.component.css']
})
export class CareLabelsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
